import * as React from "react";
import { SVGProps } from "react";
const SvgComponent = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={18}
    height={18}
    fill="none"
    {...props}
  >
    <path
      fill="#549E88"
      d="M9 1.143A7.847 7.847 0 0 0 1.143 9 7.847 7.847 0 0 0 9 16.857 7.847 7.847 0 0 0 16.857 9 7.847 7.847 0 0 0 9 1.143ZM5.333 10.31c-.733 0-1.31-.577-1.31-1.31 0-.733.577-1.31 1.31-1.31.734 0 1.31.577 1.31 1.31 0 .733-.576 1.31-1.31 1.31Zm3.667 0c-.733 0-1.31-.577-1.31-1.31 0-.733.577-1.31 1.31-1.31.733 0 1.31.577 1.31 1.31 0 .733-.577 1.31-1.31 1.31Zm3.667 0c-.734 0-1.31-.577-1.31-1.31 0-.733.576-1.31 1.31-1.31.733 0 1.31.577 1.31 1.31 0 .733-.577 1.31-1.31 1.31Z"
    />
  </svg>
);
export default SvgComponent;
